<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="form-textarea control-group"
    :class="{ error: error }"
  >
    <label
      class="control-label"
      :for="name"
    >
      <abbr
        v-if="required"
        title="Verplicht veld"
      > * </abbr>
      {{ label }}
    </label>
    <textarea
      v-if="showWysiwyg"
      :id="name"
      ref="text"
      rows="8"
      class="tinymce"
      :placeholder="placeholder"
      :value="value"
    />
    <div
      v-else-if="environment === 'registration-pdf'"
      class="content-wysiwyg-container"
    >
      <hr><hr><hr><hr><hr><hr>
    </div>
    <div
      v-else
      class="content-wysiwyg-container"
      v-html="sanitizedValue"
    />
    <span
      v-if="error && error.input"
      class="help-inline"
    >
      {{ error.input }}
    </span>
  </div>
</template>
<script>

import formatWysiwyg from '../../utils/format_wysiwyg';

export default {
  name: 'FormTextarea',

  schema: [
    {
      name: 'label',
      default: 'Label',
      type: 'FormText',
      label: 'Label',
    },
    {
      name: 'Uitleg',
      type: 'FormText',
      label: 'Placeholder',
    },
    {
      name: 'required',
      default: false,
      type: 'FormCheckbox',
      label: 'Verplicht',
    },
  ],

  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => null,
    },
    inModal: {
      type: Boolean,
      default: false,
    },
    showSubmitButton: {
      type: Boolean,
      default: false,
    },
    assigns: {
      type: Object,
      default: () => ({}),
    },
    environment: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      wysiwyg: {
        type: Object,
        default: () => ({}),
      },
    };
  },

  computed: {
    sanitizedValue() {
      return formatWysiwyg(this.value);
    },
    showWysiwyg() {
      return this.environment === 'show' || this.environment === 'builder' || this.environment === 'modal';
    },
  },

  mounted() {
    if (this.showWysiwyg) {
      this.$nextTick(() => {
        window.initTinymce(this.$refs.text, false)

        setTimeout(() => {
          this.$nextTick(() => {
            this.wysiwyg = window.tinyMCE.editors[this.name];
            if (this.wysiwyg) {
              this.wysiwyg.on('change', this.changeInput);
            }
          });
        }, 0)
      });
    }

    if (!this.inModal && this.$refs.text) {
      this.$refs.text.style.height = `${this.$refs.text.scrollHeight + 10}px`;
    }
  },

  beforeDestroy() {
    window.tinyMCE.editors[this.name].destroy();
    if (this.wysiwyg) {
      this.wysiwyg.off('change', this.changeInput);
    }
  },

  methods: {
    changeInput() {
      this.$emit('input', this.wysiwyg.getContent());
    },
  },
};
</script>

<style lang="scss">
.form-textarea {
  display: flex;
  flex-grow: 1;

  label.control-label {
    width: 50%;
    font-size: 14px;
    line-height: 30px;
    margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }

  .tox-tinymce {
    width: 50%;
  }

  .content-wysiwyg-container {
    width: 50%;
    // margin-right: 10px;
    margin-left: 25px;
    border: lightgrey solid 1px;
    border-radius: 5px;
    padding: 4px 6px;
  }

  textarea {
    width: 50%;
    resize: vertical;
    // margin-right: 10px;
  }
}
</style>
